import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  entityCardAdditionalInfo,
  entityContentScaffolderMetrics,
  entityContentReadme,
  entityCardDependabotAlertsWidget,
  entityContentUnprocessedEntities,
  entityContentArchitecture,
  entityContentApiSpecification,
  entityContentWork,
  entityCardScaffolderMetrics,
  entityCardAiAgent,
  entityCardTechRadar,
  entityContentLayout,
} from '@internal/backstage-plugin-hm-react';
import {
  CatalogLandingPage,
  CatalogLandingPageIcon,
  catalogHeaderActions,
} from '@internal/backstage-plugin-landing-pages';

/** Replaces the catalog page with the internal landing page and a custom icon. */
const catalogPageOverride = catalogPlugin
  .getExtension('page:catalog')
  .override({
    params: {
      icon: <CatalogLandingPageIcon />,
      loader: async () => <CatalogLandingPage />,
    },
  });

/** Bundles all catalog overrides and HM-specific entity extensions into a single frontend module. */
export const catalogPluginOverride = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    catalogHeaderActions,
    catalogPageOverride,
    entityCardAdditionalInfo,
    entityContentLayout,
    entityContentReadme,
    entityContentWork,
    entityContentArchitecture,
    entityContentApiSpecification,
    entityContentUnprocessedEntities,
    entityContentScaffolderMetrics,
    entityCardDependabotAlertsWidget,
    entityCardScaffolderMetrics,
    entityCardTechRadar,
    entityCardAiAgent,
  ],
});
